import { useState, useEffect } from 'react';
import gsap from 'gsap';

export default function AlertBanner() {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (!visible) return;
    const closeBtn = document.querySelector('.alert-banner-close');
    if (!closeBtn) return;

    const handleClick = () => {
      gsap.to('.alert-banner', {
        yPercent: 100,
        duration: 0.5,
        ease: 'power3.inOut',
        onComplete: () => {
          setVisible(false);
        },
      });
    };

    closeBtn.addEventListener('click', handleClick);
    return () => closeBtn.removeEventListener('click', handleClick);
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="alert-banner">
      <div className="alert-banner-text">
        Ми використовуємо cookie для належної роботи та покращення сайту.
        <a href="/tickets">Купити квитки</a>
        <button
          className="alert-banner-close"
          type="button"
          aria-label="Cerrar aviso"
        ></button>
      </div>
    </div>
  );
}
